export default __webpack_public_path__ + "0e4e0b3da55fa7faa77b4c2d978008dd.ttf";